import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode, loadingProps } from '../../../utils/global'

import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import Spinner from 'react-spinner-material'
import '../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../functions/pagination'
import { waitlist_status } from './variables/patient_1.js'

class WaitList extends Component {
  constructor() {
      super();
      //var exampleItems = [...Array(150).keys()].map(i => ({ id: (i+1), name: 'Item ' + (i+1) }));
      this.state = {
          dataItems: [], //exampleItems,
          pageOfItems: [],
          show_filter_status: 1,
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/register_patient/get_wait_list_filter',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        show_filter_status: this.state.show_filter_status,
      }
    })
    .then((result) => {
        var val = []
        if(result['data'].length > 0) {
          val = result['data']
        }
        this.setState({
          dataItems: val,
        })
      }
    )
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.getDataList()
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  render() {
    return (
      <div className="patient_dashboard box_border4">
        <div className="row">
          <div className="small-12 medium-7 columns headerPage1">
            Wait List
          </div>
          <div className="small-12 medium-5 columns">
            <FormControl variant="outlined" className="filter_waitlist_status">
              <Select value={this.state.show_filter_status} variant="outlined" label=""
                onChange={(e) => this.handleChange2(e, 'show_filter_status')}
                value={this.state.show_filter_status} >
              {waitlist_status.map(each =>
                <MenuItem key={'apt'+each.value} value={each.value}>{each.label}</MenuItem>
              )}
              </Select>
            </FormControl>
            <NavLink to='/admin/add_patient_waitlist' className="menu_list_active new_bttn new_p_btn">
              New Patient
            </NavLink>
          </div>
        </div>

        <div className="row">
          <div className="small-12 columns ">
            { typeof this.props.locationReducer.txt_message !== 'undefined' &&
              this.props.locationReducer.txt_message !== '' &&
              <div className="warning_msg3">
                <div className="float_left1"><CheckCircleOutlineIcon /></div>
                <div className="txt_warning_msg1">{ this.props.locationReducer.txt_message }</div>
              </div>
            }
            <div>
              <table className="table_data1">
                <thead className="table_head">
                  <tr>
                    <th>Name</th>
                    <th>Age</th>
                    <th>MA Resident</th>
                    <th>Status</th>
                    <th>Date Added</th>
                  </tr>
                </thead>
                <tbody>
              {!this.state.dataItems &&
                <tr>
                  <td className="loading1"><Spinner color={"#bbbbbb"} radius={50}/></td>
                </tr>}
              {this.state && this.state.dataItems && this.state.pageOfItems.map(item =>
                <tr key={item.id}>
                  <td><a href={"/admin/edit_patient_waitlist/"+item.id}>{item.fullname}</a></td>
                  <td>{item.age}</td>
                  <td>{item.ma_resident == 1 && 'Yes'}{item.ma_resident == 2 && 'No'}</td>
                  <td>{item.status == 1 && 'Active'}{item.status == 2 && 'Enrolled'}{item.status == 3 && 'Withdrawn'}</td>
                  <td>{item.create_datetime}</td>
                </tr>
              )}

              {this.state && this.state.dataItems &&
                <tr className="pagination_block">
                  <td colSpan="9">
                    <Pagination items={this.state.dataItems} pageSize={30} onChangePage={this.onChangePage} />
                  </td>
                </tr>
              }
              </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(WaitList)
